import MembershipGateway from "@/components/MembershipGateway";

export default function Membership() {
  return (
    <div data-testid="membership-page" className="pt-16">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <span className="text-xs uppercase tracking-[0.35em] text-brand-gold">
          The Circle of Intention
        </span>
        <h1 className="mt-3 font-serif text-5xl lg:text-6xl text-brand-moss leading-tight">
          Slow down with us, <span className="italic">monthly</span>.
        </h1>
        <p className="mt-5 text-lg text-brand-moss/75 max-w-2xl leading-relaxed">
          Membership is a soft commitment to your own quiet life. Ten dollars a
          month opens early access to new collections, exclusive perks, and a
          free hand-poured candle on qualifying $100+ orders.
        </p>
      </div>
      <MembershipGateway />
    </div>
  );
}
